//export const API_URL = 'http://localhost:3000';
export const API_URL = 'https://api.tecnolite.cx-mate.com';
export const API_PREFIX = 'api';
export const API_ROOT_DOMAIN = 'cx-mate.com';